import * as yup from 'yup'

export interface VehicleConformitySendBackToCanadaDto {
  needsToBeSentBackToCanada?: boolean
  sentBackToCanadaDate?: string
  sentBackToCanadaRecordNumber?: string
}

export const sendBackToCanadaValidationSchema = yup.object({
  sentBackToCanadaDate: yup.string().typeError('Sent Back To Canada is required.').required('Sent Back To Canada is required.'),
  sentBackToCanadaRecordNumber: yup.string().max(200, 'Record # cannot be more than 200 characters.').required('Record # is required.')
})
